/* ==========================================================================
Libraries
========================================================================== */
import 'jquery';
import Swiper from 'swiper';
import fancybox from 'fancybox';

global.$ = global.jQuery = jQuery;

fancybox(jQuery);

$(function(){
    /*Mobile menu button*/
    $('#mobile-btn').click(function () {
        $('#mobile-btn').toggleClass('open');
        $('.right').toggleClass('active');

    });

    /*Pop Up*/
    $('a#show-popup').click(function () {
        $('a#show-popup').toggleClass('open');
        $('.showform').toggleClass('active');

    });

    // Scrollup
    $("#scrollup").click(function(event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });

    var projectSwiper = new Swiper('#projects .swiper-container', {
        slidesPerView: 7,
        autoplay: 4000,
        speed: 1200,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is <= 320px
            500: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is <= 480px
            800: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is <= 640px
            1200: {
                slidesPerView: 5,
                spaceBetween: 30
            }
        }
    });

    var productSwiper = new Swiper('#product-type-swipe .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is <= 320px
            500: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is <= 480px
            800: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is <= 640px
            1200: {
                slidesPerView: 5,
                spaceBetween: 30
            }
        }
    });

    var newsitemSwiper = new Swiper('#newsitemslide .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is <= 320px
            500: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is <= 480px
            800: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is <= 640px
            1200: {
                slidesPerView: 5,
                spaceBetween: 30
            }
        }
    });


    $('.fancybox').fancybox();

});

